<template>
  <v-container v-if="isWordListReady" fluid>
    <v-card flat>
      <!-- タイトル -->
      <v-card-title
        v-if="mode === 'regist'"
        class="mt-3 pb-5 text-h5 font-weight-bold"
      >
        {{ wordList.lbl_scheduled_delivery_regist }}
      </v-card-title>
      <v-card-title
        v-if="mode === 'list'"
        class="mt-3 pb-5 text-h5 font-weight-bold"
      >
        {{ wordList.lbl_scheduled_delivery_list }}
      </v-card-title>
    </v-card>
    <!-- タブ設定 -->
    <v-tabs v-model="tab" hide-slider>
      <div class="tab_switch d-flex align-center">
        <v-tab
          value="tab1"
          :class="[tab === 'tab1' ? 'tab_switch_active' : 'tab_switch_inactive', 'd-flex align-center justify-center rounded-pill']"
          @click="onClickRegistTab"
        >
          {{ wordList.lbl_regist }}
        </v-tab>
        <v-tab
          value="tab2"
          :class="[tab === 'tab2' ? 'tab_switch_active' : 'tab_switch_inactive', 'ml-2 d-flex align-center justify-center rounded-pill']"
          @click="onClickListTab"
        >
          {{ wordList.lbl_list }}
        </v-tab>
      </div>
    </v-tabs>
    <!-- 店舗間定期配達登録タブ -->
    <v-window v-model="tab">
      <v-window-item value="tab1">
        <v-card v-if="mode === 'regist'" flat>
          <form>
            <v-card flat class="mt-6 pb-0">
              <!-- STEP1 -->
              <v-row>
                <v-col cols="1">
                  {{ wordList.lbl_step1 }}
                </v-col>
                <v-col cols="5">
                  {{ wordList.lbl_step1_msg }}
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="4">
                  <v-expansion-panels
                    v-model="panel"
                    flat
                    multiple
                    class="br_1"
                  >
                    <v-expansion-panel class="bk_gray_3">
                      <v-card-text>
                        <v-row class="pt-4 pb-0 px-4">
                          <!-- チェーン名 -->
                          <v-col>
                            <Field
                              v-slot="{ errors, handleChange, handleBlur }"
                              :name="wordList.lbl_chain_name"
                              rules="required"
                            >
                              <v-autocomplete
                                :model-value="chainSelectValues?.chain_code ? chainSelectValues : null"
                                density="compact"
                                :items="chainListItems"
                                item-title="name"
                                item-value="chain_code"
                                :label="wordList.lbl_chain_name"
                                :placeholder="wordList.plc_selectbox"
                                persistent-placeholder
                                :no-data-text="wordList.lbl_no_data_text"
                                :error-messages="errors"
                                bg-color="white"
                                return-object
                                variant="outlined"
                                @blur="handleBlur"
                                @update:model-value="
                                  (value) => {
                                    chainSelectValues = value;
                                    handleChange(value?.chain_code ?? '');
                                    onChangeChain();
                                  }
                                "
                              ></v-autocomplete>
                            </Field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <!-- STEP2 -->
              <v-row class="mt-6 pb-0">
                <v-col cols="1">
                  {{ wordList.lbl_step2 }}
                </v-col>
                <v-col cols="5">
                  {{ wordList.lbl_step2_msg }}
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="6">
                  <v-expansion-panels
                    v-model="panel"
                    flat
                    multiple
                    class="br_1"
                  >
                    <v-expansion-panel class="bk_gray_3">
                      <v-card-text>
                        <v-row class="pt-4">
                          <!-- 出荷元 -->
                          <v-col cols="5" class="ml-4 py-4">
                            <v-row class="py-0">
                              <v-col class="py-0">
                                {{ wordList.lbl_shop_name_from }}
                              </v-col>
                            </v-row>
                            <v-row class="py-1">
                              <v-col class="py-0">
                                <Field
                                  v-slot="{ errors, handleChange, handleBlur }"
                                  :name="wordList.lbl_shop_name_from"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    :model-value="shopSelectFromValues?.shop_code ? shopSelectFromValues : null"
                                    density="compact"
                                    :items="shopListFromItems"
                                    item-title="name"
                                    item-value="shop_code"
                                    :placeholder="wordList.plc_selectbox"
                                    persistent-placeholder
                                    :no-data-text="wordList.lbl_no_data_text"
                                    :error-messages="errors"
                                    bg-color="white"
                                    return-object
                                    variant="outlined"
                                    @blur="handleBlur"
                                    @update:model-value="
                                      (value) => {
                                        shopSelectFromValues = value;
                                        handleChange(value?.shop_code ?? '');
                                        onChangeShopFrom();
                                      }
                                    "
                                  ></v-autocomplete>
                                </Field>
                              </v-col>
                            </v-row>
                          </v-col>
                          <!-- 右矢印アイコン -->
                          <p class="mt-9">
                            <v-icon>mdi-arrow-right-bold</v-icon>
                          </p>
                          <!-- 配達先 -->
                          <v-col cols="5" class="py-4">
                            <v-row class="py-0">
                              <v-col class="py-0">
                                {{ wordList.lbl_shop_name_to }}
                              </v-col>
                            </v-row>
                            <v-row class="py-1">
                              <v-col class="py-0">
                                <Field
                                  v-slot="{ errors, handleChange, handleBlur }"
                                  :name="wordList.lbl_shop_name_to"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    :model-value="shopSelectToValues?.shop_code ? shopSelectToValues : null"
                                    density="compact"
                                    :items="shopListToItems"
                                    item-title="name"
                                    item-value="shop_code"
                                    :placeholder="wordList.plc_selectbox"
                                    persistent-placeholder
                                    :no-data-text="wordList.lbl_no_data_text"
                                    :error-messages="errors"
                                    bg-color="white"
                                    return-object
                                    variant="outlined"
                                    @blur="handleBlur"
                                    @update:model-value="
                                      (value) => {
                                        shopSelectToValues = value;
                                        handleChange(value?.shop_code ?? '');
                                        onChangeShopTo();
                                      }
                                    "
                                  ></v-autocomplete>
                                </Field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions class="justify-center py-10">
              <!-- 登録画面へボタン -->
              <v-btn
                variant="flat"
                color="primary"
                class="px-16"
                :disabled="
                  !shopSelectFromValues?.shop_code ||
                  !shopSelectToValues?.shop_code
                "
                @click="onClickOpenInputDialog"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                {{ wordList.btn_regist }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-window-item>
      <!-- } 店舗間定期配達登録タブ -->
      <!-- 店舗間定期配達一覧タブ -->
      <v-window-item value="tab2">
          <v-card flat class="mt-6">
            <!-- 検索条件入力 { -->
            <v-expansion-panels v-model="panel" flat multiple class="br_1">
              <v-expansion-panel>
                <v-expansion-panel-title
                  class="py-0 font-weight-bold bk_gray_3"
                >
                  {{ wordList.lbl_search }}
                </v-expansion-panel-title>
                <v-expansion-panel-text class="bk_gray_3">
                  <v-divider />
                  <Form v-slot="{ invalid }">
                    <v-card class="bk_gray_3" flat>
                      <v-card-text class="pt-9">
                        <v-row>
                          <!-- チェーン名 -->
                          <v-col cols="4" class="py-0">
                            <v-autocomplete
                              :model-value="chainSelectValues?.chain_code ? chainSelectValues : null"
                              density="compact"
                              :items="chainListItems"
                              item-title="name"
                              item-value="chain_code"
                              :label="wordList.lbl_chain_name"
                              :placeholder="wordList.plc_selectbox"
                              persistent-placeholder
                              :no-data-text="wordList.lbl_no_data_text"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="
                                (value) => {
                                  chainSelectValues = value;
                                  onChangeChain();
                                }
                              "
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="pt-4">
                          <!-- 出荷元 -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ errors }"
                              :name="wordList.lbl_shop_name_from"
                              rules="max:100"
                            >
                              <v-autocomplete
                                :model-value="shopSelectFromValues?.shop_code ? shopSelectFromValues : null"
                                density="compact"
                                :items="shopListFromItems"
                                item-title="name"
                                item-value="shop_code"
                                :label="wordList.lbl_shop_name_from"
                                :placeholder="wordList.plc_selectbox"
                                persistent-placeholder
                                :no-data-text="wordList.lbl_no_data_text"
                                :error-messages="errors"
                                return-object
                                variant="outlined"
                                bg-color="#fff"
                                @update:model-value="
                                  (value) => {
                                    shopSelectFromValues = value;
                                    onChangeShopFrom();
                                  }
                                "
                              ></v-autocomplete>
                            </Field>
                          </v-col>
                          <!-- 配達先 -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ errors }"
                              :name="wordList.lbl_shop_name_to"
                              rules="max:100"
                            >
                              <v-autocomplete
                                :model-value="shopSelectToValues?.shop_code ? shopSelectToValues : null"
                                density="compact"
                                :items="shopListToItems"
                                item-title="name"
                                item-value="shop_code"
                                :label="wordList.lbl_shop_name_to"
                                :placeholder="wordList.plc_selectbox"
                                persistent-placeholder
                                :no-data-text="wordList.lbl_no_data_text"
                                :error-messages="errors"
                                return-object
                                variant="outlined"
                                bg-color="#fff"
                                @update:model-value="
                                  (value) => {
                                    shopSelectToValues = value;
                                    onChangeShopTo();
                                  }
                                "
                              ></v-autocomplete>
                            </Field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- 絞り込み検索ボタン -->
                        <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mt-6"
                          :disabled="
                            invalid || !chainSelectValues?.chain_code
                          "
                          @click="onClickSearchHandler"
                        >
                          <v-icon>mdi-magnify</v-icon>
                          {{ wordList.lbl_search }}
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </Form>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- 検索条件入力 } -->
            <!-- 一覧表示  { -->
            <v-card flat width="100%">
              <v-data-table-server
                v-model="selectListCheckbox"
                v-model:options="listOptions"
                item-value="scheduled_delivery_no"
                :items-per-page="listOptions.itemsPerPage"
                :items="listDataArray"
                :items-length="listDataTotalCount"
                :loading="listLoading"
                :no-data-text="wordList.lbl_no_data_text"
                hide-default-footer
                show-select
                return-object
                :headers="tableHeaders"
                :row-props="getRowProps"
              >
                <template #top>
                  <v-row>
                    <v-col
                      cols="12"
                      class="d-flex justify-space-between mt-9 mb-5"
                    >
                      <div class="d-flex align-center">
                        <span class="pl-3">全 {{ listDataTotalCount }} 件 </span
                        ><span class="pl-1"> {{ displayPagingRange }} </span>
                        <v-pagination
                          v-model="listOptions.page"
                          :length="pageCount"
                          :total-visible="7"
                          variant="elevated"
                          density="comfortable"
                        >
                        </v-pagination>
                      </div>
                      <div v-if="!isXs">
                        <v-menu open-on-hover ocation="bottom">
                          <template #activator="{ props }">
                            <v-btn
                              variant="text"
                              color="black"
                              v-bind="props"
                              class="pr-0 pl-2"
                            >
                              アクション
                              <v-icon>mdi-cog</v-icon>
                            </v-btn>
                          </template>
                          <v-list width="250" class="pl-5">
                            <v-list-item-title
                              style="cursor: pointer"
                              @click="onClickCheckDelete"
                            >
                              <v-icon class="mr-2">mdi-delete</v-icon
                              >{{ wordList.btn_delete_all }}
                            </v-list-item-title>
                          </v-list>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <template #[`item.week`]="{ item }">
                  <span
                    v-if="item.mon_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >月
                  </span>
                  <span v-if="item.mon_to_deliver == 1" class="text-black"
                    >月
                  </span>
                  <span
                    v-if="item.tue_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >火
                  </span>
                  <span v-if="item.tue_to_deliver == 1" class="text-black"
                    >火
                  </span>
                  <span
                    v-if="item.wed_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >水
                  </span>
                  <span v-if="item.wed_to_deliver == 1" class="text-black"
                    >水
                  </span>
                  <span
                    v-if="item.thu_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >木
                  </span>
                  <span v-if="item.thu_to_deliver == 1" class="text-black"
                    >木
                  </span>
                  <span
                    v-if="item.fri_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >金
                  </span>
                  <span v-if="item.fri_to_deliver == 1" class="text-black"
                    >金
                  </span>
                  <span
                    v-if="item.sat_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >土
                  </span>
                  <span v-if="item.sat_to_deliver == 1" class="text-black"
                    >土
                  </span>
                  <span
                    v-if="item.sun_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >日</span
                  >
                  <span v-if="item.sun_to_deliver == 1" class="text-black"
                    >日</span
                  >
                </template>
                <template #[`item.actions`]="{ item }">
                  <div>
                    <v-btn
                      variant="outlined"
                      color="primary"
                      class="my-2 ml-2"
                      size="x-small"
                      icon
                      rounded="xl"
                      @click="onClickEdit(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      variant="outlined"
                      color="red"
                      class="my-2 ml-2 mr-0"
                      size="x-small"
                      icon
                      rounded="xl"
                      @click="onClickDelete(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table-server>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-card>
            <!-- 一括削除確認ダイアログ {-->
            <v-dialog
              v-model="confirmDeleteDialog"
              content-class="dialog_width_1"
              :lock-scroll="false"
              scrollable
            >
              <v-data-iterator
                :items="selectListCheckbox"
                :items-per-page="-1"
                item-key="name"
                hide-default-footer
              >
                <template #default="{ items }">
                  <v-card class="rounded-t rounded-b-0">
                    <v-card-title class="bg-red mb-5" style="color: white">
                      {{ wordList.lbl_delete_all_confirm }}
                    </v-card-title>
                    <v-card-text class="font-weight-black">
                      {{ selectListCheckbox.length }}
                      {{ wordList.lbl_delete_all_confirm_msg }}
                    </v-card-text>
                    <v-card-text  style="max-height: 60vh; overflow-y: auto;">
                    <v-card
                      v-for="item in items"
                      :key="item.raw?.scheduled_delivery_no"
                      flat
                      variant="outlined"
                      class="mb-5"
                    >
                        <v-list density="compact">
                          <!-- チェーンコード -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_chain_name }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ chainSelectValues.name }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 出荷店舗名 -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_shop_name_from }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.shopNameFrom }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 配達店舗名 -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_shop_name_to }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.shopNameTo }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 配達曜日 -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_delivery_week_list }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                <span v-if="item.raw?.mon_to_deliver === 1"
                                  >月&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.tue_to_deliver === 1"
                                  >火&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.wen_to_deliver === 1"
                                  >水&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.thu_to_deliver === 1"
                                  >木&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.fri_to_deliver === 1"
                                  >金&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.sat_to_deliver === 1"
                                  >土&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.san_to_deliver === 1">日</span>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 便名 -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_delivery_id_list }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.deliveryIdName }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 配達時間 -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_delivery_time }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.deliveryTime }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 除外日設定 -->
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black pr-0 text-right"
                              >
                                {{ wordList.lbl_blackout_date_setting }}:
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.blackoutDateSetting }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </template>
                <template #footer>
                  <v-card flat class="py-4 rounded-b rounded-t-0">
                    <v-row justify="center">
                      <!-- 戻るボタン -->
                      <v-btn
                        variant="flat"
                        color="return"
                        class="px-16 mx-2 my-2"
                        width="168px"
                        @click="confirmDeleteDialog = false"
                      >
                        <v-icon>mdi-arrow-left</v-icon>
                        {{ wordList.btn_return }}</v-btn
                      >
                      <v-btn
                        variant="outlined"
                        class="bg-red-darken-1 mx-2 my-2"
                        color="white"
                        width="168px"
                        @click="onClickCheckDeleteComplete"
                        >{{ wordList.btn_delete_all }}
                      </v-btn>
                    </v-row>
                  </v-card>
                </template>
              </v-data-iterator>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-dialog>
            <!-- } 削除確認ダイアログ -->
          </v-card>
      </v-window-item>
      <!-- } 店舗間定期配達一覧タブ -->
    </v-window>
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>

<script setup lang="ts">
import { ref, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import { OperationInput } from "@/generated/graphql";
import { localStorageGetUserId } from "@/common/localStorageUtil";
import AlertDialog from "@/components/AlertDialog.vue";
import { TABLE_HEADERS } from "./constants";
import { useScheduledDeliveryUiState } from "./composables/useScheduledDeliveryUiState";
import {
  useScheduledDeliveryFilterState,
  useScheduledDeliveryFilterHandlers,
} from "./composables/useScheduledDeliveryFilterOptions";
import { useScheduledDeliveryTable } from "./composables/useScheduledDeliveryTable";
import { useScheduledDeliveryActions } from "./composables/useScheduledDeliveryActions";
import { useScheduledDeliveryInit } from "./composables/useScheduledDeliveryInit";
import { useScheduledDeliveryRegistForm } from "./composables/useScheduledDeliveryRegistForm";

/* vee-validate 設定 */
defineRule("required", required);
defineRule("max", max);
configure({
  generateMessage: localize({
    ja,
  }),
});

const router = useRouter();
const store = useStore();

// -------------------------------
// テーブルヘッダー
// -------------------------------
const tableHeaders = TABLE_HEADERS;

// -------------------------------
// 文言データ
// -------------------------------
const wordList = reactive<Record<string, string>>({});

const requiredFieldLabelKeys = [
  "lbl_chain_name",
  "lbl_delivery_week",
  "lbl_shop_name_from",
  "lbl_shop_name_to",
] as const;

const isWordListReady = computed(() => {
  if (Object.keys(wordList).length === 0) return false;
  return requiredFieldLabelKeys.every((key) => key in wordList);
});

// -------------------------------
// 共有状態（エラーダイアログ / 操作ログ）
// -------------------------------
const errdialog = ref<boolean>(false);
const errMessage = ref<string>("");

//  配達依頼作成 logInput
const operationInput = reactive<OperationInput>({
  area_code: "10",
  detail: "操作詳細",
  display_category: "画面名",
  operation: "操作",
  user_id: localStorageGetUserId(),
});

// -------------------------------
// フィルタ状態（店舗・チェーン・エリア + データ取得関数）
// -------------------------------
const {
  chainListItems,
  chainSelectValues,
  shopListFromItems,
  shopSelectFromValues,
  shopListToItems,
  shopSelectToValues,
  shopData,
  shopData_from_name,
  shopData_from_address,
  shopData_from_zip_code,
  shopData_to_name,
  shopData_to_address,
  areaListItems,
  shopListInput,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  getShopData,
  GetAreaData,
} = useScheduledDeliveryFilterState({
  errdialog,
  errMessage,
});

// -------------------------------
// UI状態（モード/タブ/ダイアログ/オーバーレイ）
// -------------------------------
const {
  mode,
  panel,
  overlay,
  confirmDeleteDialog,
  tab,
  isXs,
  onClickRegistTab,
  onClickListTab,
} = useScheduledDeliveryUiState({
  shopSelectFromValues,
  shopSelectToValues,
});

// -------------------------------
// テーブル（一覧データ/ページング/検索）
// -------------------------------
const {
  listLoading,
  listOptions,
  listDataArray,
  listDataTotalCount,
  pageCount,
  selectListCheckbox,
  displayPagingRange,
  getRowProps,
  searchQuery,
  onClickSearch,
} = useScheduledDeliveryTable({
  chainSelectValues,
  shopSelectFromValues,
  shopSelectToValues,
  shopData,
  operationInput,
  errdialog,
  errMessage,
  getShopData,
});

// -------------------------------
// フィルタハンドラ（チェーン/店舗選択変更）
// -------------------------------
const {
  onChangeChain,
  onChangeShopFrom,
  onChangeShopTo,
} = useScheduledDeliveryFilterHandlers({
  chainSelectValues,
  shopSelectFromValues,
  shopSelectToValues,
  shopListFromItems,
  shopListToItems,
  shopData,
  shopData_from_name,
  shopData_from_address,
  shopData_from_zip_code,
  shopData_to_name,
  shopData_to_address,
  shopListInput,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  listOptions,
  listDataTotalCount,
  listDataArray,
  errdialog,
  errMessage,
  getShopData,
  GetAreaData,
});

// -------------------------------
// 初期化（onMounted/文言/チェーン取得/編集画面戻り）
// -------------------------------
const {
  isUpdateModeBack,
} = useScheduledDeliveryInit({
  overlay,
  errdialog,
  errMessage,
  chainListItems,
  chainSelectValues,
  shopSelectFromValues,
  shopSelectToValues,
  wordList,
  onClickListTab,
  onChangeChain,
  onClickSearch,
});

// template から呼ばれる検索ハンドラ
const onClickSearchHandler = () => onClickSearch(isUpdateModeBack);

// -------------------------------
// アクション（編集/削除/一括削除）
// -------------------------------
const {
  onClickEdit,
  onClickDelete,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
} = useScheduledDeliveryActions({
  selectListCheckbox,
  confirmDeleteDialog,
  overlay,
  errdialog,
  errMessage,
  chainSelectValues,
  shopSelectFromValues,
  shopSelectToValues,
  operationInput,
  searchQuery,
  router,
  store,
});

// -------------------------------
// 登録（配達便チェック/登録画面遷移）
// -------------------------------
const {
  onClickOpenInputDialog,
} = useScheduledDeliveryRegistForm({
  chainSelectValues,
  shopSelectFromValues,
  shopSelectToValues,
  deliverableAreaDeliveryIdInput,
  errdialog,
  errMessage,
  router,
  store,
});
</script>

<style scoped></style>
